(() => {
  const money = (cents) => {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents) / 100); }
    catch { return `$${(Number(cents) / 100).toFixed(2)}`; }
  };

  document.addEventListener('click', (event) => {
    const quantityButton = event.target.closest('[data-spr-qty]');
    if (quantityButton) {
      const form = quantityButton.closest('form');
      const input = form?.querySelector('[data-spr-quantity]');
      if (!input) return;
      const current = Math.max(1, Number.parseInt(input.value || '1', 10));
      input.value = String(quantityButton.dataset.sprQty === 'plus' ? current + 1 : Math.max(1, current - 1));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const menuLink = event.target.closest('.spr-mobile-drawer a');
    if (menuLink) menuLink.closest('[data-spr-mobile-menu]')?.removeAttribute('open');
  });

  document.querySelectorAll('[data-spr-product]').forEach((root) => {
    const data = root.querySelector('[data-spr-variants]');
    const variantInput = root.querySelector('[data-spr-variant-id]');
    const price = root.querySelector('[data-spr-price]');
    const add = root.querySelector('[data-spr-add]');
    if (!data || !variantInput || !price || !add) return;
    let variants = [];
    try { variants = JSON.parse(data.textContent || '[]'); } catch { return; }
    const groups = [...root.querySelectorAll('[data-spr-option-index]')];
    const update = () => {
      const selected = groups.map((group) => group.querySelector('input:checked')?.value || '');
      const variant = variants.find((candidate) => selected.every((value, index) => candidate.options[index] === value)) || variants[0];
      if (!variant) return;
      variantInput.value = variant.id;
      price.innerHTML = `${money(variant.price)}${variant.compare_at_price > variant.price ? ` <s>${money(variant.compare_at_price)}</s>` : ''}`;
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to Cart' : 'Sold out';
      const mediaId = variant.featured_media?.id || variant.featured_image?.id;
      if (mediaId) root.querySelector(`[data-spr-media-id="${mediaId}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    };
    groups.forEach((group) => group.addEventListener('change', update));
  });
})();
